import React from 'react'
import { BackButton } from 'src/editor/shared/components/back-button'
import { twMerge } from 'tailwind-merge'

export interface SettingsNestedMenuScreenProps {
  className?: string
  title: string
  children: React.ReactNode
  onClose?: () => void
}

export const SettingsNestedMenuScreen = ({
  className,
  title,
  children,
  onClose,
}: SettingsNestedMenuScreenProps) => {
  return (
    <div className="absolute inset-0 z-90 overflow-y-auto bg-bgPrimaryBase">
      <div className="m-[var(--sidebar-padding)]">
        <BackButton className="mb-6!" onClick={onClose} />
        <div className={twMerge('mb-7 text-heading-4', className)}>{title}</div>
        {children}
      </div>
    </div>
  )
}
